/**
 * SEE-1738: how the CDK transports tell CdkSessionGuard a request was refused
 * as Unauthorized. A leaf module: it imports nothing from `app/**`, because
 * authSlice already imports the services and a store import here would cycle.
 *
 * The event carries no payload. The guard always asks the server
 * (checkPaidolSession) what to do, so nothing here is trusted for decisions.
 */

export const CDK_REFUSAL_EVENT = 'speedchain:cdk-refusal';

// A refusal of the check itself (or of the call that creates the session it
// checks) must not start another check: it would recurse.
const SELF_OPERATIONS = new Set(['checkPaidolSession', 'createOrGetPaidolSession']);

export interface CdkRefusalContext {
  authMode?: string;
  operationName?: string;
}

/** Fire-and-forget. Never throws and never changes the caller's control flow. */
export function reportCdkRefusal(errors: unknown, ctx: CdkRefusalContext): void {
  try {
    if (ctx.authMode === 'iam') return;
    if (ctx.operationName && SELF_OPERATIONS.has(ctx.operationName)) return;
    if (!Array.isArray(errors) || errors.length === 0) return;
    const first: unknown = errors[0];
    if (!first || typeof first !== 'object') return;
    if ((first as { errorType?: unknown }).errorType !== 'Unauthorized') return;
    window.dispatchEvent(new Event(CDK_REFUSAL_EVENT));
  } catch {
    // Reporting is best-effort; the transport's own error handling is unchanged.
  }
}
